import { Injectable, Injector } from '@angular/core';
import { map, finalize } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { MultiTenancyService, ConfigStateService, AbpTenantService, SessionStateService, AbpApplicationConfigurationService } from '@abp/ng.core';
import { __rest } from 'tslib';
import { ToasterService } from '@abp/ng.theme.shared';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@abp/ng.core';
import * as ɵngcc2 from '@abp/ng.theme.shared';
class AuthWrapperService {
    constructor(multiTenancy, configState, injector) {
        this.multiTenancy = multiTenancy;
        this.configState = configState;
        this.isMultiTenancyEnabled$ = this.configState.getDeep$('multiTenancy.isEnabled');
        this.tenantBoxKey = 'Account.TenantBoxComponent';
        this.route = injector.get(ActivatedRoute);
    }
    get enableLocalLogin$() {
        return this.configState
            .getSetting$('Abp.Account.EnableLocalLogin')
            .pipe(map(value => (value === null || value === void 0 ? void 0 : value.toLowerCase()) !== 'false'));
    }
    get isTenantBoxVisibleForCurrentRoute() {
        var _a;
        return (_a = this.getMostInnerChild().data.tenantBoxVisible) !== null && _a !== void 0 ? _a : true;
    }
    get isTenantBoxVisible() {
        return this.isTenantBoxVisibleForCurrentRoute && this.multiTenancy.isTenantBoxVisible;
    }
    getMostInnerChild() {
        let child = this.route.snapshot;
        let depth = 0;
        const depthLimit = 10;
        while (child.firstChild && depth < depthLimit) {
            child = child.firstChild;
            depth++;
        }
        return child;
    }
}
AuthWrapperService.ɵfac = function AuthWrapperService_Factory(t) { return new (t || AuthWrapperService)(ɵngcc0.ɵɵinject(ɵngcc1.MultiTenancyService), ɵngcc0.ɵɵinject(ɵngcc1.ConfigStateService), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
AuthWrapperService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthWrapperService, factory: AuthWrapperService.ɵfac });
AuthWrapperService.ctorParameters = () => [
    { type: MultiTenancyService },
    { type: ConfigStateService },
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthWrapperService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.MultiTenancyService }, { type: ɵngcc1.ConfigStateService }, { type: ɵngcc0.Injector }]; }, null); })();

class TenantBoxService {
    constructor(toasterService, tenantService, sessionState, configState, appConfigService) {
        this.toasterService = toasterService;
        this.tenantService = tenantService;
        this.sessionState = sessionState;
        this.configState = configState;
        this.appConfigService = appConfigService;
        this.currentTenant$ = this.sessionState.getTenant$();
    }
    onSwitch() {
        const tenant = this.sessionState.getTenant();
        this.name = tenant === null || tenant === void 0 ? void 0 : tenant.name;
        this.isModalVisible = true;
    }
    save() {
        if (!this.name) {
            this.setTenant(null);
            this.isModalVisible = false;
            return;
        }
        this.modalBusy = true;
        this.tenantService
            .findTenantByName(this.name, {})
            .pipe(finalize(() => (this.modalBusy = false)))
            .subscribe((_a) => {
            var { success, tenantId: id } = _a, tenant = __rest(_a, ["success", "tenantId"]);
            if (!success) {
                this.showError();
                return;
            }
            this.setTenant(Object.assign(Object.assign({}, tenant), { id, isAvailable: true }));
            this.isModalVisible = false;
        });
    }
    setTenant(tenant) {
        this.sessionState.setTenant(tenant);
        this.appConfigService.get().subscribe(res => this.configState.setState(res));
    }
    showError() {
        this.toasterService.error('AbpUiMultiTenancy::GivenTenantIsNotAvailable', 'AbpUi::Error', {
            messageLocalizationParams: [this.name],
        });
    }
}
TenantBoxService.ɵfac = function TenantBoxService_Factory(t) { return new (t || TenantBoxService)(ɵngcc0.ɵɵinject(ɵngcc2.ToasterService), ɵngcc0.ɵɵinject(ɵngcc1.AbpTenantService), ɵngcc0.ɵɵinject(ɵngcc1.SessionStateService), ɵngcc0.ɵɵinject(ɵngcc1.ConfigStateService), ɵngcc0.ɵɵinject(ɵngcc1.AbpApplicationConfigurationService)); };
TenantBoxService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: TenantBoxService, factory: TenantBoxService.ɵfac });
TenantBoxService.ctorParameters = () => [
    { type: ToasterService },
    { type: AbpTenantService },
    { type: SessionStateService },
    { type: ConfigStateService },
    { type: AbpApplicationConfigurationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TenantBoxService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.ToasterService }, { type: ɵngcc1.AbpTenantService }, { type: ɵngcc1.SessionStateService }, { type: ɵngcc1.ConfigStateService }, { type: ɵngcc1.AbpApplicationConfigurationService }]; }, null); })();

/*
 * Public API Surface of account-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthWrapperService, TenantBoxService };

//# sourceMappingURL=abp-ng.account.core.js.map